import { motion } from "framer-motion";

// Masked line-by-line reveal. Pass an array of lines (strings or nodes).
export const RevealHeading = ({
  lines = [],
  className = "",
  delay = 0,
  stagger = 0.12,
  as: Tag = "h1",
  testId,
}) => {
  return (
    <Tag className={className} data-testid={testId}>
      {lines.map((line, i) => (
        <span className="reveal-line" key={i}>
          <motion.span
            style={{ display: "block", willChange: "transform" }}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 1,
              delay: delay + i * stagger,
              ease: [0.19, 1, 0.22, 1],
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

// Scroll-triggered reveal wrapper
export const Reveal = ({ children, className = "", delay = 0, y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.19, 1, 0.22, 1] }}
  >
    {children}
  </motion.div>
);
